export default __webpack_public_path__ + "static/media/cpv_65_public-facilities.2c82e905.svg";